// extracted by mini-css-extract-plugin
export default {"lang__btn":"styles_lang__btn__KUHKv"};